// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2084":"299d7115","2682":"299d7115","7121":"299d7115","7862":"299d7115","8435":"299d7115"}[chunkId] + ".chunk.css";
};